import angular from 'angular';
import buscadorController from './buscador-avanzado.controller';
import template from './buscador-avanzado.html';



const MODULE_NAME = 'buscador.componentes.buscador-avanzado';

const ngModule=angular.module(MODULE_NAME, [buscadorController]);


ngModule.component('buscador',{

    controller:'buscadorController',
    controllerAs:'app',
    template:template

});

export default MODULE_NAME;





// WEBPACK FOOTER //
// ./src/busqueda/componentes/buscador-avanzado/buscador-avanzado.component.js